module.exports = __webpack_public_path__ + "static/media/AshevilleHempFarms1newstorefront1downtownAsheville2020Watergildedandhandlettered.d52e86c2.webp";